module.exports = __webpack_public_path__ + "static/img-migracion-caadbd0cb7808166bd41f79ed1241c0b.svg";